/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMattermostIcon20Solid = forwardRef('LogoMattermostIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m14.785 5.225-.084-1.698a7.998 7.998 0 1 1-4.487-1.524L9.119 3.296c-2.026.367-3.775 1.75-4.462 3.781-1.023 3.022.691 6.332 3.83 7.395 3.137 1.062 6.51-.527 7.533-3.548.685-2.024.142-4.178-1.235-5.699Z" }),
        React.createElement("path", { d: "M12.59 2.91c.048 1.875.098 3.751.15 5.627.037 1.623-1.472 2.828-3.024 2.302-1.552-.525-2.02-2.399-1.004-3.665 1.18-1.459 2.372-2.91 3.537-4.38.123-.12.32-.064.342.115Z" })));
});
